const Footer = ({ fixed = false, children }) => {
  return (
    <footer>
      <img alt="Sign 로고" src="/assets/img/logo.svg" className="logo" />
    </footer>
  )
}

export default Footer;